import {
  DueOutCount,
  DueOutFetchArgs,
  getDueOutCount,
} from '../../assets/ts/data/dueout/dueout'
import useServerData from '../use-server-data'

function useDueOutCount(fetchArgs: DueOutFetchArgs) {
  const {
    data: dueOutCount,
    error: dueOutCountError,
    fetchData: fetchDueOutCount,
    isLoading: dueOutCountIsLoading,

  } = useServerData<DueOutCount, DueOutFetchArgs>(
    getDueOutCount,
    fetchArgs
  )

  const count = dueOutCount?.[0]?.DueOutGUID_count ?? 0

  return {
    dueOutCountError,
    dueOutCountIsLoading,
    dueOutCountValue: count,
    fetchDueOutCount,
  }
}

export default useDueOutCount
